import { RootState } from 'models/store';

// ==============================|| DELIVERY POINT SELECTORS ||============================== //

export const selectDeliveryContractList = (state: RootState) =>
  state.eai.deliveryContract.deliveryContractListInterface.deliveryContractList;

export const selectDeliveryContractListPage = (state: RootState) =>
  state.eai.deliveryContract.deliveryContractListInterface.page;

export const selectDeliveryContractDetail = (state: RootState) =>
  state.eai.deliveryContract.deliveryContractDetail;

export const selectDeliveryContractDeliveryPoints = (state: RootState) =>
  state.eai.deliveryContract.deliveryPoints;
